<template>
  <div
    v-if="callIncoming || callInProgress"
    class="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-between px-4 py-2 bg-emerald-700 text-white shadow-lg"
  >
    <div class="flex items-center gap-3">
      <i class="pi pi-phone text-xl" />
      <div v-if="callIncoming && !callInProgress">
        <span class="font-semibold">{{ $t('Appel entrant') }}</span>
        <span v-if="callerFrom" class="ml-2">{{ callerFrom }}</span>
      </div>
      <div v-if="callInProgress" class="flex items-center gap-3">
        <span class="font-semibold">{{ $t('En cours') }}</span>
        <span v-if="callerFrom">{{ callerFrom }}</span>
        <Tag severity="info" :value="formattedDuration" />
      </div>
    </div>

    <div class="flex items-center gap-2">
      <Button
        v-if="callIncoming && !callInProgress"
        icon="pi pi-phone"
        severity="success"
        size="small"
        :label="$t('Décrocher')"
        @click="acceptIncomingCall"
      />
      <Button
        v-if="callIncoming && !callInProgress"
        icon="pi pi-times"
        severity="danger"
        size="small"
        :label="$t('Ignorer')"
        @click="ignoreCall"
      />
      <Button
        v-if="callInProgress"
        :icon="callIsMuted ? 'pi pi-microphone-slash' : 'pi pi-microphone'"
        :severity="callIsMuted ? 'warn' : 'secondary'"
        size="small"
        :label="callIsMuted ? $t('Unmute') : $t('Mute')"
        @click="muteCall"
      />
      <Button
        v-if="callInProgress"
        icon="pi pi-phone"
        severity="danger"
        size="small"
        :label="$t('Raccrocher')"
        @click="disconnectCall"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCall } from '../composables/useCall'

const {
  callIncoming,
  callInProgress,
  callIsMuted,
  callerFrom,
  formattedDuration,
  acceptIncomingCall,
  ignoreCall,
  muteCall,
  disconnectCall,
} = useCall()
</script>
